import React, { useEffect, useState } from "react";

import { useNavigate, useTranslation, useUserContext } from "utils";

import { Anchor, Bookmark, ContentRating, ErrorBoundary, Modal, SocialSharePopover } from "components";

/**
 *
 * @param type {(ARTICLE_NEWS.ARTICLE|ARTICLE_NEWS.NEWS)} ARTICLE_NEWS
 * @param share {({ title: string, summary: string,link: string,image:string})}
 * @param initialValue {({allowed: boolean, rating: RATING_STATUS, saved: boolean})} UserActions
 * @param onRatingChange
 * @param onSavedChange
 * @returns {JSX.Element}
 * @constructor
 */
export const UserActions = ({ type, share, initialValue, onRatingChange, onSavedChange }) => {
  const { t } = useTranslation("articles");

  const { user } = useUserContext();

  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [userActions, setUserActions] = useState(initialValue);

  const disabled = !user || !userActions?.allowed;

  const handleContentRatingChanged = (v) => {
    if (disabled) {
      setShowModal(true);
      return;
    }
    onRatingChange(v);
  };

  const handleSavedChanged = (v) => {
    if (disabled) {
      setShowModal(true);
      return;
    }
    onSavedChange(v);
  };

  useEffect(() => {
    setUserActions(initialValue);
  }, [initialValue]);

  return (
    <>
      <div className="flex-center-space-between" data-testid={`${type}-user-actions`}>
        <div>
          <ErrorBoundary>
            <ContentRating type={type} initialValue={userActions?.rating} onChange={handleContentRatingChanged} disabled={disabled} iconSize="m" />
          </ErrorBoundary>
        </div>
        <div>
          <ErrorBoundary>
            <SocialSharePopover className="margin-right-100" dataTestId={type} t={t} share={share} saved={userActions?.allowed} iconSize="m" />
          </ErrorBoundary>
          <ErrorBoundary>
            <Bookmark
              dataTestId={`${type}-bookmark`}
              checked={userActions?.saved}
              onChange={handleSavedChanged}
              disabled={disabled}
              tooltipText={t("post.buttons.save")}
              iconSize="m"
              colour="#202020"
            />
          </ErrorBoundary>
        </div>
      </div>
      <Modal
        dataTestId={`${type}-modal-signed-out`}
        showModal={showModal}
        onOk={() => navigate("/sign-up")}
        onCancel={() => setShowModal(false)}
        title={t("signUpNudgeModal.title")}
        okText={t("signUpNudgeModal.logInLinkText")}
        destroyOnHidden={true}
        content={
          <>
            <p className="paragraph-m">{t("signUpNudgeModal.body")}</p>
            <p className="paragraph-s">
              {t("signUpNudgeModal.haveAccount")}{" "}
              <Anchor type="link" size="small" dataTestId="users-signup-modal-login-link" to="/sign-in">
                {t("signUpNudgeModal.logInLinkText")}
              </Anchor>
            </p>
          </>
        }
      />
    </>
  );
};
